import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1448.57 288.052 1084.46 502.746 1448.55 718.026 1813.23 502.732 1448.57 288.052zM959.965 429.191 1323.92 214.589 959.988 0 596.032 214.602 959.965 429.191zM835.499 502.732 471.388 288.038 106.704 502.732 471.388 718.026 835.499 502.732zM106.667 1416.54 960 1920 1813.33 1416.54 960 913.07 106.667 1416.54z"
});

var IconInstructureLogoLine = /*#__PURE__*/function (_Component) {
  _inherits(IconInstructureLogoLine, _Component);

  var _super = _createSuper(IconInstructureLogoLine);

  function IconInstructureLogoLine() {
    _classCallCheck(this, IconInstructureLogoLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconInstructureLogoLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconInstructureLogo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconInstructureLogoLine.displayName = "IconInstructureLogoLine";
  return IconInstructureLogoLine;
}(Component);

IconInstructureLogoLine.glyphName = 'instructure-logo';
IconInstructureLogoLine.variant = 'Line';
IconInstructureLogoLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconInstructureLogoLine;
export { IconInstructureLogoLine };